export const DELEO_STATUS_TO_EVENT_TYPE: Record<string, string> = {
  D06: 'delivered',
  I04: 'customsCleared',
  I03: 'inCustoms',
  I02: 'arrivedDestination',
  I01: 'departed',
  I00: 'invoiceIssued',
};

export const DELEO_DELIVERED_STATUS = 'D06';

